'use strict'

import ajax from '@/plugin/ajax.js'

const login = function (account, pwd, code) {
    let url = '/Sys/Account/Login'
    let data = {
        account: account,
        pwd: pwd,
        code: code
    }

    return ajax.post(url, data)
}

const loginout = function () {
    let url = '/Sys/Account/Logout'
    return ajax.post(url)
}

const getAuthConfig = function () {
    let url = '/Sys/Account/Config'
    return ajax.post(url)
}

const selectTenant = function (id) {
    let url = '/Sys/Account/SelectTenant'
    let data = {
        tenantId: id
    }

    return ajax.post(url, data)
}
const setDefaultTenant = function (id) {
    let url = '/Sys/Account/SetDefaultTenant'
    let data = {
        tenantId: id
    }

    return ajax.post(url, data)
}

const Syslogin = function (account, pwd, code,uuid,validCode) {
    let url = '/api/Sys_Account/Login'
    let data = {
        account: account,
        pwd: pwd,
        code: code,
        uuid: uuid,
        validCode: validCode
    }

    return ajax.post(url, data)
}

const isNeedChangePassworld = function(){
    let url = '/api/SysEmployee/isNeedChangePassworld'

    return ajax.post(url)
}

const getCodeImg = function(){
    let url = '/api/SysEmployee/CreateValidGraphic'
    return ajax.get(url)
}

const getSmsCode = function(model){
    let url = '/api/SysEmployee/CreateMobileVerificationCode'
    return ajax.post(url,model)
}

export { login, loginout, getAuthConfig, selectTenant, setDefaultTenant,Syslogin,isNeedChangePassworld,getCodeImg,getSmsCode }
